module.exports = __webpack_public_path__ + "static/img/hoverlogo06.db269675.png";